<div class="main-content p-4 pb-7 d-flex align-items-center flex-column position-relative">
  <img ngSrc="assets/logos/logo-mogenius-neg.svg" class="logo me-auto" alt="" width="150" height="28" priority />
  <div class="content-inner" style="margin-top: max(100px, calc(50vh - 400px))">
    <router-outlet></router-outlet>
  </div>
</div>
<mo-logged-out-sidebar></mo-logged-out-sidebar>
